import api from '../api'

class Figma {
  private static clientId = import.meta.env.VITE_FIGMA_CLIENT_ID

  private static scope = 'file_content:read'

  private static responseType = 'code'

  private static state: {
    [key: string]: any
  } = {}

  static authenticate() {
    return window.open(
      Figma.getAuthUrl(),
      'Login with Figma',
      `dialog=yes,width=1000px,height=1000px`
    )
  }

  static authorize(state: { [key: string]: any } = {}):
    | Promise<{
        user_id: number
        access_token: string
        refresh_token: string
        expires_in: number
        error?: boolean
      }>
    | undefined {
    Figma.state = state

    const token = window.localStorage.getItem('token')

    if (state.type === 'code' && token) {
      return api.Auth.figma({
        token,
        code: Figma.state.data,
        redirectUri: Figma.callbackUrl(),
      })
    }
  }

  static page() {}

  static rerun() {}

  private static generateTokenUrl() {
    return 'https://api.octdev.cc/integration/figma'
  }

  private static generateAuthUrl() {
    const { clientId, responseType, scope } = Figma
    const redirectUri = Figma.callbackUrl()

    return `https://www.figma.com/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}&state=null`
  }

  private static callbackUrl() {
    const { href } = window.location

    if (href.includes('localhost')) {
      return 'http://localhost:3000/oauth/callback/figma'
    }

    if (href.includes('oct-1743')) {
      return 'https://oct-1743.octdev.cc/oauth/callback/figma'
    }

    if (href.includes('octdev.cc')) {
      return 'https://octdev.cc/oauth/callback/figma'
    }

    return 'https://octopus.do/oauth/callback/figma'
  }

  static getAuthUrl() {
    return Figma.generateAuthUrl()
  }

  static getTokenUrl() {
    return Figma.generateTokenUrl()
  }
}

export default Figma
